import React, { useEffect, useMemo, useState } from "react";
import { Tab, Tabs } from "react-bootstrap";
import { useLocation } from "react-router";
import {
	DiagnosticProductApi,
	ErrorDiagnosticProduct,
	LayerDiagnosticProduct,
} from "src/services/Api/Organization/types";
import { LoadingContainer } from "go-core/components/Loading";
import { apiOrganization } from "../../../../../../../../../../services/Api/Organization/apiOrganization";
import SubmenuProductDiagnosticNavigation from "../../components/SubmenuProductDiagnosticNavigation";

const OrganizationSettingsDiagnosticProductOpenAmountPage = () => {
	const [layers, setLayers] = useState<DiagnosticProductApi[] | undefined>(undefined);
	const [loading, setLoading] = useState<boolean>(true);
	const { search } = useLocation();
	const searchParams = useMemo(() => new URLSearchParams(search), [search]);
	const params = Object.fromEntries(searchParams);
	const productId = Number(params.product_id);

	const fetch = async (productId: number) => {
		if (params.only_error === undefined) params.only_error = "1";

		const data = await apiOrganization.getOrganizationDiagnosticOpenAmountProduct(productId, params);
		setLayers(data);
		setLoading(false);
	};
	useEffect(() => {
		if (params.product_id !== undefined) {
			fetch(productId);
		}
	}, []);
	if (!productId) return <>Produkt nie istnieje</>;
	if (loading) return <LoadingContainer />;
	return (
		<div>
			<SubmenuProductDiagnosticNavigation id={productId} />

			<Tabs
				defaultActiveKey={layers !== undefined && layers?.length > 0 ? `nav_stock_${layers[0].stock_id}` : ""}
				id="diagnostic_stocks"
				className="mb-3"
			>
				{layers?.map((dataStock) => {
					return (
						<Tab
							eventKey={`nav_stock_${dataStock.stock_id}`}
							title={`${dataStock.name} (ID: ${dataStock.stock_id}, Q: ${dataStock.products.length})`}
							key={dataStock.stock_id}
						>
							<div>
								<table className="table">
									<thead>
										<tr>
											<th>Layer id / data</th>
											<th>Typ dokumentu</th>
											<th>Errory</th>
											<th>Ilości (aktualna, jaka powinna, różnica)</th>
										</tr>
									</thead>
									<tbody>
										{dataStock.products.map((dataStockProduct: LayerDiagnosticProduct) => {
											return (
												<tr key={dataStockProduct.layer_id}>
													<td>
														{dataStockProduct.date}
														{" | "}
														{dataStockProduct.layer_id}
													</td>
													<td>{dataStockProduct.document_type}</td>
													<td>
														{dataStockProduct.errors.map(
															(error: ErrorDiagnosticProduct) => {
																return (
																	<p key={error.type}>
																		<small>{error.type}</small>
																		<br />
																		{error.message}
																	</p>
																);
															}
														)}
													</td>
													<td>
														<p className={"m-0"}>
															Ilość / otwarta: {dataStockProduct.amount} /{" "}
															{dataStockProduct.open_amount}
														</p>
														<p className={"m-0"}>
															Cena jednostki: {dataStockProduct.price_per_one.amount} vs{" "}
															{dataStockProduct.price_per_one.should_amount} (Diff:{" "}
															{dataStockProduct.price_per_one.diff_amount})
														</p>
														<p className={"m-0"}>
															Wartość otwartej ilości:{" "}
															{dataStockProduct.should_open_fifo_price.amount} vs{" "}
															{dataStockProduct.should_open_fifo_price.should_amount}{" "}
															(Diff: {dataStockProduct.should_open_fifo_price.diff_amount}
															)
														</p>
														<p className={"m-0"}>
															Ilość zużyta: {dataStockProduct.should_used_amount.amount}{" "}
															vs {dataStockProduct.should_used_amount.should_amount}{" "}
															(Diff: {dataStockProduct.should_used_amount.diff_amount})
														</p>
														<p className={"m-0"}>
															Wartość zużytej ilości:{" "}
															{dataStockProduct.should_used_price.amount} vs{" "}
															{dataStockProduct.should_used_price.should_amount} (Diff:{" "}
															{dataStockProduct.should_used_price.diff_amount})
														</p>
														<p className={"m-0"}>
															Wartość layer vs transaction:{" "}
															{dataStockProduct.diff_transaction_price.amount} vs{" "}
															{dataStockProduct.diff_transaction_price.should_amount}{" "}
															(Diff: {dataStockProduct.diff_transaction_price.diff_amount}
															)
														</p>
													</td>
												</tr>
											);
										})}
									</tbody>
								</table>
							</div>
						</Tab>
					);
				})}
			</Tabs>
		</div>
	);
};

export default OrganizationSettingsDiagnosticProductOpenAmountPage;
